module.exports = __webpack_public_path__ + "img/Schulmaterial_Russlandvonoben_mobile.008d2da7.png";